import React from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
import ModalHeader from 'components/Modal/ModalHeader';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import {
  setSelectedOutletsModal,
  setUnlinkOutletsModal,
  hideModalAssignOutletsOnRegistration,
  linkOutletToBankAccount,
} from 'actions/setting/paymentMethod';
import styles from './ModalAssignOutletsOnRegistration.css';

class ModalAssignOutletsOnRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
    };
  }

  render() {
    const {
      showModalAssignOutletsOnRegistration,
      outlets,
      selectedOutlets,
      handleSubmit,
    } = this.props;

    return (
      <Modal
        show={showModalAssignOutletsOnRegistration}
        className={`${styles.modalAssignOutlet}`}
      >
        <ModalHeader title="Assign Outlet" />
        <form onSubmit={handleSubmit}>
          <Modal.Body style={{ height: 400 }}>
            <Field
              component={SearchBar}
              className={`${styles.searchWrapper}`}
              placeholder="Search"
              id="SearchModal"
              onChange={this._onChangeKeyword}
            />
            <div className={styles.tableWrapper}>
              <div>
                <table className={`table ${styles.tableNoMargin}`}>
                  <thead>
                    <tr>
                      <th className={styles.tableOutletName}>Select Outlet</th>
                      <th className={styles.tableOutletStatus}>
                        <a
                          onClick={
                            this._isDisableSaveToAll()
                              ? this._returnFalse()
                              : this._onSelectAllOutlets
                          }
                        >
                          Select All
                        </a>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className={styles.tableBodyWrapper}>
                <table className={`table ${styles.tableNoMargin}`}>
                  <tbody>
                    {outlets.map(outlet => {
                      const regex = new RegExp(`${this.state.keyword}`, 'i');
                      if (outlet.name.search(regex) !== -1) {
                        return (
                          <tr key={outlet.id}>
                            <td
                              style={{ border: 'none' }}
                              className={styles.tableOutletName}
                            >
                              <div className={styles.textWrapper}>
                                <div className={styles.textElipsis}>
                                  {outlet.name}
                                  {this._isHasBeenRegisteredPaymentMethod(
                                    outlet.id
                                  ) ||
                                  this._isHasBeenAssignedOtherBank(
                                    outlet.id
                                  ) ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        this._isHasBeenRegisteredPaymentMethod(
                                          outlet.id
                                        ) ? (
                                          <Tooltip id="tooltip">
                                            This outlet is being used for mobile
                                            payment settlement, so you can not
                                            select / unselect it.
                                          </Tooltip>
                                        ) : this._isHasBeenAssignedOtherBank(
                                            outlet.id
                                          ) ? (
                                          <Tooltip id="tooltip">
                                            This outlet is already assigned to
                                            another bank account, so you can not
                                            select / unselect it.
                                          </Tooltip>
                                        ) : (
                                          ''
                                        )
                                      }
                                    >
                                      <img
                                        style={{
                                          position: 'relative',
                                          top: '-2px',
                                          marginLeft: 30,
                                          cursor: 'pointer',
                                        }}
                                        src={require('assets/images/info-tooltip.png')}
                                      />
                                    </OverlayTrigger>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            </td>
                            <td
                              style={{ border: 'none' }}
                              className={styles.tableOutletStatus}
                            >
                              <div className="col-lg-1">
                                <div
                                  style={{ marginTop: '2px' }}
                                  className={`checkbox checkbox-primary checkbox-box`}
                                >
                                  <Field
                                    id={outlet.id}
                                    name={outlet.name}
                                    component="input"
                                    type="checkbox"
                                    checked={
                                      this._isHasBeenSelectedBefore(
                                        outlet.id
                                      ) ||
                                      this._isHasBeenAssignedOtherBank(
                                        outlet.id
                                      )
                                    }
                                    disabled={
                                      this._isHasBeenAssignedOtherBank(
                                        outlet.id
                                      ) ||
                                      this._isHasBeenRegisteredPaymentMethod(
                                        outlet.id
                                      )
                                    }
                                    onChange={this._onSelectOutlet}
                                  />
                                  <label htmlFor={outlet.id} />
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              Selected Outlet :{' '}
              {outlets.length === selectedOutlets.length
                ? 'All Outlets'
                : selectedOutlets.length}
            </span>
            <span className="pull-right">
              <button
                className="btn btn-default"
                onClick={this._onCancelAssign}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                disabled={selectedOutlets.length === 0}
                onClick={handleSubmit(this._onClickAssign)}
              >
                Assign
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _isHasBeenSelectedBefore = outletId => {
    return _.find(this.props.selectedOutlets, ['id', outletId]) !== undefined;
  };

  _isHasBeenAssigned = (outletId, otherBank) => {
    const { bankAccountDetail } = this.props;
    const outletStatus = _.find(this.props.assignedOutlets, ['id', outletId]);
    const findResult = outletStatus !== undefined;

    if (!bankAccountDetail) return findResult;
    if (!otherBank) {
      return (
        findResult && bankAccountDetail.bankAccId === outletStatus.bankAccId
      );
    }
    return findResult && bankAccountDetail.bankAccId !== outletStatus.bankAccId;
  };

  _isHasBeenAssignedToThisBank = outletId => {
    return this._isHasBeenAssigned(outletId, false);
  };

  _isHasBeenAssignedOtherBank = outletId => {
    return this._isHasBeenAssigned(outletId, true);
  };

  _isHasBeenRegisteredPaymentMethod = outletId => {
    const { paymentMethodOutlets } = this.props;
    let result = false;

    _.each(paymentMethodOutlets, paymentMethod => {
      if (
        paymentMethod.outlet_statuses &&
        paymentMethod.outlet_statuses[outletId] !== undefined
      ) {
        result = true;
        return false;
      }
    });
    return result;
  };

  _onSelectOutlet = (event, value) => {
    const outlet = {};
    outlet.id = parseInt(event.target.id);
    outlet.name = event.target.name;

    const outlets = value
      ? _.concat(this.props.selectedOutlets, outlet)
      : _.reject(this.props.selectedOutlets, ['id', outlet.id]);

    if (this._isHasBeenAssignedToThisBank(outlet.id)) {
      const unlinkOutlets = !value
        ? _.concat(this.props.unlinkOutlets, outlet.id)
        : _.without(this.props.unlinkOutlets, outlet.id);

      this.props.dispatch(setUnlinkOutletsModal(unlinkOutlets));
    }
    this.props.dispatch(setSelectedOutletsModal(outlets));
  };

  _onSelectAllOutlets = () => {
    let { outlets } = this.props;
    outlets = _.filter(outlets, outlet => {
      return !this._isHasBeenAssignedOtherBank(outlet.id);
    });
    this.props.dispatch(setSelectedOutletsModal(outlets));
  };

  _onCancelAssign = e => {
    this.props.dispatch(hideModalAssignOutletsOnRegistration());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickAssign = () => {
    const { bankAccountDetail, selectedOutlets, unlinkOutlets } = this.props;
    this.props.dispatch(
      linkOutletToBankAccount(bankAccountDetail, selectedOutlets, unlinkOutlets)
    );
  };

  _onChangeKeyword = (event, keyword) => {
    this.setState({ keyword });
  };

  _returnFalse = () => {
    return false;
  };

  _isDisableSaveToAll = () => {
    const { rightColumnType, outletStatus, bankAccountDetail } = this.props;
    if (rightColumnType === 'form') {
      return outletStatus.length !== 0;
    }
    if (rightColumnType === 'edit') {
      const outlets = _.reject(outletStatus, [
        'bankAccId',
        bankAccountDetail.bankAccId,
      ]);
      return outlets.length !== 0;
    }
  };
}

function mapStatetoProps(state) {
  const {
    assignedOutlets,
    outlets,
    outletStatus,
    bankAccountDetail,
    showModalAssignOutletsOnRegistration,
    selectedOutlets,
    unlinkOutlets,
    paymentMethods,
    paymentMethodOutlets,
    rightColumnType,
  } = state.setting.paymentMethod;
  return {
    addBankForm: getFormValues('bankAccount')(state),
    assignedOutlets,
    outlets,
    outletStatus,
    bankAccountDetail,
    paymentMethodOutlets,
    showModalAssignOutletsOnRegistration,
    selectedOutlets,
    unlinkOutlets,
    paymentMethods,
    rightColumnType,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'assignOutlets',
};

export default reduxForm(mapForm)(
  connect(
    mapStatetoProps,
    mapDispatchToProps
  )(ModalAssignOutletsOnRegistration)
);
